module.exports = __webpack_public_path__ + "img/WP2023-Icon-Courses.583b4748.svg";